import React from 'react';

export class Model extends React.Component {
	public render() {
		return (
			<div />
		);
	}
}